export function useFeatureFlag() {
  const isEnabled = useFeatureFlagEnabled()

  const personalization = usePersonalizationStore()

  watch(
    () => personalization.settings,
    (settings) => {
      if (settings.featureFlagAccess === true) {
        isEnabled.value = true
      }
    },
    { immediate: true, deep: true },
  )

  watch(isEnabled, (value) => {
    personalization.settings.featureFlagAccess = value
  })

  return isEnabled
}
